import { render, staticRenderFns } from "./Retencion.vue?vue&type=template&id=7addb4ca&lang=pug&"
import script from "./Retencion.vue?vue&type=script&lang=js&"
export * from "./Retencion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports